<template>
  <div class="multiple_choice_one">
    <div class="answers">
      <h6>Select One Option</h6>
      <div v-for="answer in answers" :key="answer.id">
        <b-form-radio
          :name="answer.the_answer"
          :checked="selectedAnswerId"
          :value="answer.id"
          class="answer"
          @change="checkChanged"
        >
          {{ answer.freeform ? 'Other' : answer.the_answer }}
        </b-form-radio>
      </div>
      <div v-if="isOtherSelected" class="freeform mt-3">
        <b-form-textarea
          :ref="'freeform-' + question.id"
          v-model="textAnswer"
          cols="85"
          placeholder="Please specify"
          @focusout="clickOut"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { useSurveyResponseStore } from '@app/stores/SurveyResponseStore.ts'
import { useValidationStore } from '@/survey/stores/ValidationStore.ts'

export default {
  props: {
    question: { type: Object, required: true },
  },
  emits: ['change'],
  data() {
    return {
      selectedAnswerId: null,
      textAnswer: null,
    }
  },
  computed: {
    ...mapState(useSurveyResponseStore, ['surveyResponses', 'findResponseByQuestionId']),
    ...mapState(useValidationStore, ['addError', 'registerValidationFunction', 'validate']),
    answers() {
      return this.question.answers
    },
    response() {
      return this.findResponseByQuestionId(this.question.id)
    },
    responseData() {
      return {
        question_id: this.question.id,
        response_id: this.response?.id,
        answer_id: this.selectedAnswerId,
        text_answer: this.textAnswer,
      }
    },
    isOtherSelected() {
      return this.answers.find((a) => a.freeform && a.id == this.selectedAnswerId)
    },
  },
  mounted() {
    this.registerValidationFunction(this.question.id, this._validate)
    this.selectedAnswerId = this.response?.answer_id
    this.textAnswer = this.response?.text_answer
  },
  methods: {
    checkChanged(answerId) {
      this.selectedAnswerId = answerId

      if (!this.isOtherSelected) {
        this.textAnswer = null
      } else {
        this.$nextTick(() => {
          this.$refs['freeform-' + this.question.id].focus()
        })
      }

      this.$emit('change', this.responseData)
      this.validate(this.question.id)
    },
    clickOut() {
      if (this.textAnswer === this.response?.text_answer) return

      this.validate(this.question.id)
      this.$emit('change', this.responseData)
    },
    _validate() {
      if (!this.question.required) return

      if (!this.selectedAnswerId) {
        this.addError(this.question.id, 'Please select an answer')
      }

      if (this.isOtherSelected && !this.textAnswer) {
        this.addError(this.question.id, 'Please specify your answer')
      }
    },
  },
}
</script>
<style lang="sass" scoped>
.answer
  margin-bottom: 10px
  ::v-deep .custom-control-label
    cursor: pointer
    width: 100%
.freeform
  margin-left: 24px
</style>
